import { getGioParamsByTempId, getGioParamsByWorkId, eventBuryingPoint } from '@/services/gio'
import eventMap from './eventMap'

/**
 * gio统计，根据origin从event文件里区分是否当前渠道生效
 * @param eventName
 * @param eventParams
 */
export default function gioTrackEvent(eventName: string, eventParams?: Record<string, any>) {
  if (!eventName) return
  if (eventParams && typeof eventParams === 'object') {
    window.gio?.('track', eventName, eventParams)
  } else {
    window.gio?.('track', eventName)
  }
}

const TRACK_TYPE = {
  TEMPLATE: 'TEMPLATE',
  WORK: 'WORK',
}

const isMS = (memberShip: any) => {
  if (typeof memberShip === 'boolean') {
    return memberShip ? '是' : '否'
  }
  return ''
}

/**
 * 模板跟踪事件
 */
const gioTrackTmpEvent = async (
  params: Record<string, any> = {},
  eventName: string,
  eventParams: Record<string, any> = {},
) => {
  try {
    const { data = {} } = await getGioParamsByTempId(params)
    if (data?.code === 0) {
      const result = data?.result || []
      const trackParams: any = result.map(
        ({
          categoryName,
          creativeApproach,
          festival,
          fileType,
          industryName,
          isMemberShip,
          size,
          templateNumber,
        }: any) => ({
          ...eventParams,
          industry: industryName,
          category_cz: categoryName,
          creative_method: creativeApproach,
          holiday: festival,
          creative_type: fileType,
          is_user_member: isMS(isMemberShip),
          template_number: templateNumber,
          size,
        }),
      )
      const current = trackParams[0] || {}
      if (eventName === eventMap.edit_cz) {
        // 编辑
        gioTrackEvent(eventName, current)
      }
      if (eventName === eventMap.template_or_case_click_cz) {
        // 模板或案例点击
        gioTrackEvent(eventName, current)
      }
      if (eventName === eventMap.export_cz) {
        // 导出
        gioTrackEvent(eventName, current)
      }
    }
  } catch (e) {
    console.error(e)
  }
}
gioTrackTmpEvent.type = TRACK_TYPE

const gioTrackWorkEvent = async (
  params: Record<string, any> = {},
  eventName: string,
  eventParams: Record<string, any> = {},
) => {
  try {
    const { data = {} } = await getGioParamsByWorkId(params)
    if (data?.code === 0) {
      const result = data?.result || []
      const trackParams: any = result.map(
        ({
          categoryName,
          creativeApproach,
          festival,
          fileType,
          industryName,
          isMemberShip,
          size,
          origin,
          templateNumber,
        }: any) => ({
          ...eventParams,
          industry: industryName,
          category_cz: categoryName,
          creative_method: creativeApproach,
          holiday: festival,
          creative_type: fileType,
          is_user_member: isMS(isMemberShip),
          template_number: templateNumber,
          work_source: origin,
          size,
        }),
      )
      const current = trackParams[0] || {}
      if (eventName === eventMap.edit_cz) {
        // 编辑
        gioTrackEvent(eventName, current)
      }
      if (eventName === eventMap.template_or_case_click_cz) {
        // 模板或案例点击
        gioTrackEvent(eventName, current)
      }
      if (eventName === eventMap.export_cz) {
        // 导出
        gioTrackEvent(eventName, current)
      }
      if (eventName === eventMap.distribute_cz) {
        // 分发 - 此处支持多个
        // gioTrackEvent(eventName, trackParams)
        eventBuryingPoint(
          trackParams.map((param: any) => ({
            eventKey: eventName,
            eventParams: param,
          })),
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
}
gioTrackWorkEvent.type = TRACK_TYPE

export { eventMap, gioTrackTmpEvent, gioTrackWorkEvent }
